import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Advantages = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  margin: '5px 0 20px',

  [theme.breakpoints.down('sm')]: {
    gap: '10px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: '11px',
  },
}));

export const Advantage = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
  color: 'rgba(108, 106, 124, 1)',

  svg: {
    fontSize: '18px',
  },

  [theme.breakpoints.down('sm')]: {
    gap: '0',

    '.MuiTypography-root': {
      fontSize: '11px',
      lineHeight: '14.3px',
    },
  },
}));
